import { createSelector } from 'reselect';

import { coworkingSelector } from '../root/coworkingSelector';

export const getCoworkingOperator = createSelector(coworkingSelector, coworking => coworking?.operator || null);
